

export class CustomResponseBE {
    ResultCode: string = '';
}